module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('instamapsBreadcrumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBreadcrumbs),
      expression: "hasBreadcrumbs"
    }],
    attrs: {
      "title": _vm.$t('title')
    }
  }), _vm._v(" "), _c('instamapsGalleryFeatured', {
    attrs: {
      "availableMaps": _vm._availableMaps,
      "lastActivity": _vm._lastActivity,
      "selectedLang": _vm.selectedLang,
      "btnUrl": _vm.btnUrl
    }
  }), _vm._v(" "), _c('instamapsGalleryList', {
    attrs: {
      "selectedLang": _vm.selectedLang
    },
    on: {
      "login": function($event) {
        _vm.login()
      },
      "loading": function($event) {
        _vm.loading()
      },
      "loaded": function($event) {
        _vm.loaded($event)
      },
      "clonarMapa": function($event) {
        _vm.showModalClonar($event)
      }
    }
  }), _vm._v(" "), _c('instamapsClonarModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalClonarIsLoaded,
      "mapa": _vm.currentMapa
    },
    on: {
      "loaded": _vm.loadedClonar,
      "error": _vm.showModalError
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19dbbac8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gallery/gallery.vue
// module id = 291
// module chunks = 0